/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelLocalesList64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelLocalesList64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M16 14C15.4477 14 15 14.4477 15 15V45C15 45.5523 15.4477 46 16 46H38.252C38.0875 45.3608 38 44.6906 38 44C38 39.5817 41.5817 36 46 36C46.3387 36 46.6724 36.021 47 36.0619V15C47 14.4477 46.5523 14 46 14H16Z"
            fill="currentColor"
          />
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15 45C15 45.5523 15.4477 46 16 46H38.252C38.1682 45.6742 38.1043 45.3404 38.0619 45H16V36H46C46.3387 36 46.6724 36.021 47 36.0619V15C47 14.4477 46.5523 14 46 14H16C15.4477 14 15 14.4477 15 15V45ZM46 15H16V24H46V15ZM46 35V25H16V35H46Z"
              fill="currentColor"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M46 38C49.3137 38 52 40.6863 52 44C52 47.3137 49.3137 50 46 50C42.6863 50 40 47.3137 40 44C40 40.6863 42.6863 38 46 38ZM46 49C46.2456 49 46.7372 48.7749 47.2269 47.7954C47.6361 46.9771 47.9292 45.8255 47.9888 44.5H44.0112C44.0708 45.8255 44.3639 46.9771 44.7731 47.7954C45.2628 48.7749 45.7544 49 46 49ZM44.0112 43.5H47.9888C47.9292 42.1745 47.6361 41.0229 47.2269 40.2046C46.7372 39.2251 46.2456 39 46 39C45.7544 39 45.2628 39.2251 44.7731 40.2046C44.3639 41.0229 44.0708 42.1745 44.0112 43.5ZM47.9139 48.6206C48.5173 47.6198 48.9215 46.1551 48.9897 44.5H50.9753C50.79 46.366 49.5789 47.9302 47.9139 48.6206ZM48.9897 43.5H50.9753C50.79 41.634 49.5789 40.0698 47.9139 39.3794C48.5173 40.3802 48.9215 41.8449 48.9897 43.5ZM44.0861 39.3794C43.4827 40.3802 43.0785 41.8449 43.0103 43.5H41.0247C41.21 41.634 42.4211 40.0698 44.0861 39.3794ZM44.0861 48.6206C42.4211 47.9302 41.21 46.366 41.0247 44.5H43.0103C43.0785 46.1551 43.4827 47.6198 44.0861 48.6206Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelLocalesList64Icon.tags = [
  'list',
  'language',
  'global',
  'menu',
  'select',
  'globe',
];

AddPanelLocalesList64Icon.category = '64x64 (Add panel)';

AddPanelLocalesList64Icon.iconSize = 64;
